<template>
    <div class="background">
        <div class="content">
            <h4 v-if="from == 'RC'">merci de votre reservation !<br>Vous recevrez très vite un e-mail récapitulatif :)</h4>
            <h4 v-if="from == 'CP'">merci pour vos éléments !<br>Vous recevrez très vite un e-mail récapitulatif :)</h4>
            <button v-if="from == 'CP'" @click="newCP">Nouvelle création graphique</button>
            <div class="button" @click="goHome()">
                <span>retourner sur défipix.fr</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        from: String
    },
    methods: {
        newCP() {
            this.$store.commit('newCP');
        },
        goHome() {
            window.location = "http://www.defipix.fr";
        }
    }
}
</script>

<style scoped>
.background {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
}

.content {
    background-color: rgb(248, 248, 248);
    border-radius: 5px;
    padding: 2em;
    box-shadow: 0px 0px 5px 0px #aaa;
}

.button {
    background-color: #101588;
    color: #fff;
    font-weight: 600;
    padding: 1em;
    width: max-content;
    margin: 2em auto 0 auto;
    border-radius: 15px;
}

.button:hover {
    cursor: pointer;
    color: #f677c4;
}
</style>>



// WEBPACK FOOTER //
// src/components/Merci.vue